import React from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import UpgradeButton from '../../organization/UpgradeButton';
import { openPricingModal } from '../../utils/url/pricingPath';
import * as styles from './InsightsRestriction.module.scss';

interface InsightsRestrictionProps {
  olderThan?: number;
  onUpgradeClick?: () => void;
}

const InsightsRestriction = ({
  olderThan,
  onUpgradeClick,
}: InsightsRestrictionProps) => {
  const dispatch = useAppDispatch();

  const upgradeClick = () => {
    onUpgradeClick?.();
    openPricingModal(dispatch, 'usageAnalytics');
  };

  return (
    <div className={styles.container}>
      <div className={styles.note}>
        {olderThan
          ? `Upgrade to view data older than ${olderThan} days.`
          : 'Upgrade to view older analytics data.'}
      </div>
      <UpgradeButton onClick={() => upgradeClick()} size="small">
        View upgrade options
      </UpgradeButton>
    </div>
  );
};

export default InsightsRestriction;
